module.exports = __webpack_public_path__ + "images/user-blocked-e0035ea58ec2d3ef89ac001f6f10d1c3.png";